import { FC } from "react";
import { Path, Svg } from "react-native-svg";

import { tSvgProps } from "../types";

const PdClose: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 9 9" fill="none" {...props}>
    <Path
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      focusable={false}
      d="M9 0.53027L8.46973 0L4.5 3.96973L0.53027 0L0 0.53027L3.96973 4.5L0 8.46973L0.53027 9L4.5 5.03027L8.46973 9L9 8.46973L5.03027 4.5L9 0.53027Z"
      fill="currentColor"
    />
  </Svg>
);

export default PdClose;
